// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const AppInfoModalLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-appinfomodal" */ "@ms/planner-presentational-controls/lib/local/appInfoModal/AppInfoModal")).then((bundle)=>{
        return {
            default: bundle.AppInfoModal
        };
    });
export const LazyAppInfoModal = /*#__PURE__*/ lazy(AppInfoModalLazyLoader);
